import React from 'react';
import { observer } from 'mobx-react';
import { Box, Paragraph, IconButton } from 'components';
import { Chat, Download } from 'icons';
import { CadPreview, makeDecimalIdLink } from 'libs/connection/cells';
import { PortalLink } from 'apps/client/components/PortalLink';
import { Link } from 'core/routing';
import { ProductQuoteApp } from '../app';

const wrapperStyle = {
  display: 'flex',
  alignItems: 'end',
  justifyContent: 'space-between',
};

const rowStyles = {
  display: 'flex',
  alignItems: 'center',
};

export const ProductQuoteHeader = observer(
  ({ productQuoteApp }: { productQuoteApp: ProductQuoteApp }) => {
    const rfq = productQuoteApp.from;
    const { file } = rfq.jobSpec.build;
    return (
      <Box sx={wrapperStyle}>
        <Box sx={rowStyles}>
          <PortalLink name='rfq' params={{ rfqId: rfq.id }}>
            {file ? CadPreview(file) : <p>Cannot get preview...</p>}
          </PortalLink>
          <Box ml={6}>
            <Paragraph>
              <strong>{rfq.jobSpec.build.file.filename}</strong>
            </Paragraph>
            <Paragraph>
              RFQ ID:{' '}
              {makeDecimalIdLink({ routeName: 'rfq', paramName: 'rfqId' })(
                rfq.id,
              )}
            </Paragraph>
          </Box>
        </Box>
        <Box>
          <a
            href={file?.permalink}
            download
            target='_blank'
            rel='noopener noreferrer'
          >
            <IconButton variant='outlined' icon={<Download />} mr={4} />
          </a>
          <PortalLink
            name='rfq'
            params={{ rfqId: rfq.id, panel: 'discuss' }}
            target='_blank'
            // rel='noopener noreferrer'
          >
            <IconButton variant='outlined' icon={<Chat />} />
          </PortalLink>
        </Box>
      </Box>
    );
  },
);
